import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Diovoid Prints ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" etsy.com/shop/Diovoid ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" In this company, my objective is to develop and facilitate easy accessibility to 3D printed designs for networking and PC-related components, while also accommodating custom design requests. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createBlock(_component_ion_card, {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToSite()))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_card_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card_title, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_ion_icon, {
                icon: _ctx.chevronForwardOutline,
                class: "ion-card-arrows"
              }, null, 8, ["icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card_subtitle, null, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_card_content, null, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}